import Vue from 'vue'
import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import {
  faAngleDoubleRight,
  faQuestionCircle,
  faPodcast,
  faPaperPlane,
  faUndoAlt
} from "@fortawesome/free-solid-svg-icons"
import {
  faFacebookSquare,
  faTwitterSquare,
  faInstagramSquare,
  faLinkedin,
  faTwitter
} from "@fortawesome/free-brands-svg-icons"

library.add(faAngleDoubleRight,
        faQuestionCircle,
        faPodcast,
        faPaperPlane,
        faFacebookSquare,
        faTwitterSquare,
        faInstagramSquare,
        faLinkedin,
        faTwitter,
        faUndoAlt)

Vue.component("font-awesome-icon", FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
